import domtoimage from 'dom-to-image'

export const ICON_BUTTON_ID = 'ICON_BUTTON_ID'
export const ROOT_CONTAINER_ID = 'ROOT_CONTAINER_ID'
export const PROGRESS_GRAPH_ROOT_CONTAINER_ID = 'PROGRESS_GRAPH_ROOT_CONTAINER_ID'
export const ENGAGEMENT_QUARTILE_GRAPH_ROOT_CONTAINER_ID = 'ENGAGEMENT_QUARTILE_GRAPH_ROOT_CONTAINER_ID'
export const PACE_GRAPH_ROOT_CONTAINER_ID = 'PACE_GRAPH_ROOT_CONTAINER_ID'

const filter = node => node.id !== ICON_BUTTON_ID
const exportToImage = async (chart, format, exportFunc) => {
  try {
    const dataUrl = await exportFunc(chart, { filter })
    const link = document.createElement('a')
    document.body.appendChild(link)
    link.download = `chart.${format}`
    link.href = dataUrl
    link.click()
    link.remove()
  } catch (err) {
    console.error('oops, something went wrong!', err)
  }
}

export const exportToJpeg = chart => exportToImage(chart, 'jpeg', domtoimage.toJpeg)
export const exportToPng = chart => exportToImage(chart, 'png', domtoimage.toPng)
export const print = async chart => {
  try {
    const dataUrl = await domtoimage.toJpeg(chart, { filter })
    let html = '<html><head><title></title></head>'
    html += '<body style="width: 100%; padding: 0; margin: 0;"'
    html += ' onload="window.focus(); window.print(); window.close()">'
    html += `<img src="${dataUrl}" /></body></html>`

    const printWindow = window.open('', 'print')
    printWindow.document.open()
    printWindow.document.write(html)
    printWindow.document.close()
  } catch (err) {
    console.error('oops, something went wrong!', err)
  }
}

export const EXPORT_OPTIONS = [
  { key: 'Print', action: print, text: 'Print' },
  { key: 'JPEG', action: exportToJpeg, text: 'Save as JPEG' },
  { key: 'PNG', action: exportToPng, text: 'Save as PNG' }
]
